import { Dropdown } from "antd";

const InputSearchDropdown = ({ menu, children }) => {
  return <Dropdown menu={menu}>{children}</Dropdown>;
};

export default InputSearchDropdown;
